import 'object_entries';
import { Footer } from 'components/Footer';
import 'idempotent-babel-polyfill';

declare const global: any;

// These Components need to be global for ReactJS.net to use them
global.Footer = Footer;
